import { compose, withHandlers } from 'recompose'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as EndUserActions from 'app/modules/endUser/actions'
import { track } from 'app/modules/tracking/actions'

import CQLBar from './component'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updateCQL: EndUserActions.updateCQL,
  }, dispatch),
})

export default compose(
  connect(undefined, mapDispatchToProps),
  withHandlers({
    onClick: props => score => () => {
      track(`Conversation Sidebar - CQL Score Changed`)
      props.actions.updateCQL({
        conversationId: props.conversationId,
        endUserId: props.endUserId,
        score: props.score === score ? 0 : score,
      })
    },
  }),
)(CQLBar)



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Person/CQLBar/index.js